const _excluded = ["onSubmit", "simplified", "titleMP", "subtitleMP"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useState } from 'react';
import cn from 'classnames';
import { Controller, useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { emailValidation } from 'validators';
import { TextField, Typography, useIsMounted } from 'seagull';
import GoogleButton from "../../../../components/GoogleButton/GoogleButton";
import IntuitButton from "../../../../components/IntuitButton/IntuitButton";
import { routes } from "../../../../constants";
import { useIoContext, useStoreActions } from "../../../../contexts";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { handlePromise } from "../../../../infra/utils";
import { FormSeparatorHorizontal } from "../../components/FormSeparator";
import { useLocationCommonActions } from "../../../../providers/LocationProvider";
import { ErrorMessage, FooterLink, FooterText, FormContainer, FormFields, VerticalFormFields, SubmitButtonField } from "../../components/FormComponents";
import TermsAndPrivacyMessage from "../../components/TermsAndPrivacyMessage";
import XeroSignInButton from "../../components/XeroSignInButton/XeroSignInButton";
import { errorMessages } from "../../constants";
import sharedStyles from "../LoginScreen.module.scss";
import styles from "./Email.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const loginFlowEndpoint = '/login/flow';
export default function EmailStep(_ref) {
  var _useLocation;
  let {
      onSubmit,
      simplified,
      titleMP,
      subtitleMP
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {
    LOGIN_WITH_XERO
  } = useFeatureFlags();
  const {
    afterEmailVerification
  } = ((_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.state) || {
    afterEmailVerification: false
  };
  const {
    cookies
  } = useIoContext();
  const existingEmail = cookies.getUserEmailFromUserDetailsCookie();
  const {
    handleSubmit,
    control,
    formState
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: existingEmail || ''
    }
  });
  const {
    api
  } = useStoreActions();
  const isMounted = useIsMounted();
  const {
    getPageUrl
  } = useLocationCommonActions();
  async function onEmailFormSubmit(_ref2) {
    let {
      email
    } = _ref2;
    setErrorMessage(null);
    setIsLoading(true);
    const result = await handlePromise(api.auth.loginEmailStep(email, getPageUrl()));
    if (result.success) {
      const {
        flow
      } = result.data;
      onSubmit({
        email,
        flow: flow
      });
    } else {
      setErrorMessage(errorMessages.generalLoginError);
    }
    if (isMounted()) {
      setIsLoading(false);
    }
  }
  return /*#__PURE__*/_jsxs(FormContainer, _objectSpread(_objectSpread({}, props), {}, {
    onSubmit: handleSubmit(onEmailFormSubmit),
    children: [titleMP, subtitleMP, afterEmailVerification && /*#__PURE__*/_jsx(Typography, {
      className: sharedStyles.simplifiedEnterEmailMsg,
      skin: "success",
      "data-testid": "email-verified-msg",
      children: "Your account has been confirmed"
    }), /*#__PURE__*/_jsx(FormFields, {
      children: /*#__PURE__*/_jsxs(VerticalFormFields, {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [simplified && /*#__PURE__*/_jsx(Typography, {
            className: cn(sharedStyles.emailPrompt, sharedStyles.withBottomMargin, sharedStyles.centeredText),
            children: "Please enter your email address to access your account"
          }), /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "email",
            defaultValue: "",
            rules: emailValidation(undefined, {
              required: true
            }),
            render: _ref3 => {
              var _fieldState$error;
              let {
                field,
                fieldState
              } = _ref3;
              return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
                collapseHelperText: false
              }, field), {}, {
                type: "email",
                label: simplified ? 'Email address' : 'Work email',
                error: fieldState.isTouched && !!fieldState.error,
                helperText: fieldState.isTouched && ((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
                "data-testid": "email-input",
                placeholder: "Work email",
                disabled: isLoading,
                autoComplete: "username"
              }));
            }
          })]
        }), /*#__PURE__*/_jsx(SubmitButtonField, {
          disabled: !formState.isValid,
          isLoading: isLoading,
          "data-testid": "login-button",
          children: simplified ? 'Send code' : 'Sign in'
        }), !simplified && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormSeparatorHorizontal, {
            children: "Or"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.oauthButtonsContainer,
            children: [/*#__PURE__*/_jsx(GoogleButton, {
              testid: "google-btn-sign-in",
              onAuthError: msg => {
                setErrorMessage(msg || errorMessages.generalLoginError);
              }
            }), LOGIN_WITH_XERO && /*#__PURE__*/_jsx(XeroSignInButton, {
              location: window.location,
              mode: "signIn"
            }), /*#__PURE__*/_jsx(IntuitButton, {
              mode: "signIn"
            })]
          })]
        })]
      })
    }), errorMessage && /*#__PURE__*/_jsx(ErrorMessage, {
      "data-testid": "err-message",
      children: errorMessage
    }), /*#__PURE__*/_jsxs("div", {
      className: sharedStyles.footer,
      children: [!simplified && /*#__PURE__*/_jsxs(FooterText, {
        children: ["No account?", ' ', /*#__PURE__*/_jsx(FooterLink, {
          toInternalLink: routes.signUp,
          "data-testid": "sign-up-link",
          children: "Sign up for free"
        })]
      }), /*#__PURE__*/_jsx(TermsAndPrivacyMessage, {
        type: "login"
      })]
    })]
  }));
}